import { useI18n } from "@/shared/composables/use-i18n";
import { useToast } from "primevue/usetoast";
import { watchEffect } from "vue";
import { Options, setup, Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Breadcrumb from "primevue/breadcrumb";
import { BreadcrumbItem } from "@/shared/models/breadcrumb";

export enum BreadCrumbsLevel {
    OurCars = 1,
    Grouping = 2,
    Details = 3,
}

@Options({
    components: { Breadcrumb },
})
export class AppBreadcrumbs extends Vue {
    toast = setup(useToast);
    i18n = setup(useI18n);

    @Prop({ required: true, default: BreadCrumbsLevel.OurCars })
    breadCrumbsLevel!: BreadCrumbsLevel;
    @Prop({ required: false, default: "Car details" })
    detailsLabel!: string;
    @Prop({ required: false, default: "" })
    hash!: string;

    breadCrumbsHome = { label: "Home", route: "/" };
    breadCrumbsItems: BreadcrumbItem[] = [];

    mounted() {
        this.updateBreadcrumbs();
        watchEffect(() => {
            this.updateBreadcrumbs();
        });
    }

    private updateBreadcrumbs() {
        this.breadCrumbsItems = [
            {
                label: this.i18n?.t("cart.breadcrumbs.ourCars"),
                route: "/auth/vehicles-grouped",
                level: 1,
            },
            {
                label: this.i18n.t("cart.breadcrumbs.groupingMode"),
                route: this.hash
                    ? `/auth/vehicles?grouping_mode=1&hashcode=${this.hash}`
                    : "/auth/vehicles-grouped",
                level: 2,
            },
            {
                label: this.detailsLabel,
                level: 3,
            },
        ].slice(0, this.breadCrumbsLevel);
    }
}
